import React, { ReactNode } from 'react';
import styled from 'styled-components';

const List = styled.ul<{ height: number }>`
  border: 1px solid lightgrey;
  border-radius: 3px;
  background-color: white;
  height: ${props => `${props.height}px`};
  margin: 0;
  overflow-y: scroll;
  padding: 0px;

  ::-webkit-scrollbar-track {
    background: white;
  }
`;

interface IResultListToggleProps {
  children: ReactNode;
  height?: number;
}

const listHeight = 340;

export default (props: IResultListToggleProps) => {
  const { children, height = listHeight } = props;
  return <List height={height}>{children}</List>;
};
